export const splitPhone = (phone) => {
	if (phone.startsWith("381")) {
		return {
			countryCode: phone.substr(0, 3),
			rest: phone.substr(3)
		};
	} else if (phone.startsWith("+381")) {
		return {
			countryCode: phone.substr(0, 4),
			rest: phone.substr(4)
		};
	} else {
		return {
			countryCode: "+1",
			rest: phone
		};
	}
};
